import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import 'react-slidedown/lib/slidedown.css'
import Dropdown from '../../../dropdown'
import config from '../../../../config'

import { AuthGDPR } from '../common/AuthGDPR'
import { AuthResponsable } from '../common/AuthResponsable'
import { AuthEdat17 } from '../common/AuthEdat17'

import { AuthCompromis, AuthCompromisMenors16 } from './AuthCompromis'
import { AuthImatgeMaterial } from './AuthImatgeMaterial'
import { AuthPortatils } from './AuthPortatils'
import { AuthSortides, AuthSortidesMenors } from './AuthSortides'
import { AuthSortidaEsbarjo } from './AuthSortidaEsbarjo'
import { AuthSortidaHorari } from './AuthSortidaHorari'
import { AuthDanys, AuthDanysMenors } from './AuthDanys'
import { AuthMedica } from './AuthMedica'
import { AuthQuota } from './AuthQuota'

export function EnrolmentFormAuthorizations(props) {

  const [errors, setErrors] = useState({});

  const handleErrors = (nom, error) => {
    //console.log('error', nom, error)
    setErrors(error)
  }

  /* AUTORITZACIONS */
  const [authorizationsOpen, setAuthorizationsOpen] = useState(true);

  const toggleAuthorizationsOpen = () => {
    setAuthorizationsOpen(!authorizationsOpen);
  }

  const [authIntranet, setAuthIntranet] = useState(false);
  const [authPublicacions, setAuthPublicacions] = useState(false);
  const [authMaterial, setAuthMaterial] = useState(false);
  const [authMaterialNomCognoms, setAuthMaterialNomCognoms] = useState(false);
  const [authMaterialInicials, setAuthMaterialInicials] = useState(false);
  const [authMaterialExposat, setAuthMaterialExposat] = useState(false);
  const [authInternet, setAuthInternet] = useState(false);

  const [authCompromis, setAuthCompromis] = useState("0");
  const [authGDPR, setAuthGDPR] = useState("0");
  const [authSortides, setAuthSortides] = useState("0");
  const [authMedica, setAuthMedica] = useState("0");
  const [authResponsable, setAuthResponsable] = useState("0");
  const [authPortatils, setAuthPortatils] = useState("0");
  const [authImatgeProhibicions, setAuthImatgeProhibicions] = useState("0");
  const [authQuota, setAuthQuota] = useState("0");
  const [authSortidaEsbarjo, setAuthSortidaEsbarjo] = useState("0");
  const [authSortidaHorari, setAuthSortidaHorari] = useState("0");
  const [authDanys, setAuthDanys] = useState("0");

  const major16 = props.dadesPersonals.edat >= 16 || false
  const major18 = props.dadesPersonals.edat >= 18 || false
  const esMonografic = props.dadesEstudis.curs.id.startsWith("MONO")
  const authPortatilsCriteria = props.dadesEstudis.curs.id.startsWith("ESOLOE") || props.dadesEstudis.curs.id.startsWith("BATXLOE")

  const handleDadesAutoritzacions = (noError) => {
    let d = {
      "validat": noError,

      /* DADES AUTORITZACIONS */
      "authIntranet": authIntranet,
      "authPublicacions": authPublicacions,
      "authMaterial": authMaterial,
      "authMaterialNomCognoms": authMaterialNomCognoms,
      "authMaterialInicials": authMaterialInicials,
      "authMaterialExposat": authMaterialExposat,
      "authInternet": authInternet,
      "authCompromis": authCompromis,
      "authGDPR": authGDPR,
      "authSortides": authSortides,
      "authSortidaEsbarjo": authSortidaEsbarjo,
      "authSortidaHorari": authSortidaHorari,
      "authDanys": authDanys,
      "authMedica": authMedica,
      "authResponsable": authResponsable,
      "authPortatils": authPortatils,
      "authImatgeProhibicions": authImatgeProhibicions,
      "authQuota": authQuota
    }

    props.handleDadesAutoritzacions(d)
  }

  const validaAuthIntranet = () => {
    return authIntranet ? null : "Heu d'indicar una resposta"
  }

  const validaAuthPublicacions = () => {
    return authPublicacions ? null : "Heu d'indicar una resposta"
  }

  const validaAuthMaterial = () => {
    return authMaterial ? null : "Heu d'indicar una resposta"
  }

  const validaAuthMaterialInicials = () => {
    return authMaterialInicials ? null : "Heu d'indicar una resposta"
  }

  const validaAuthMaterialNomCognoms = () => {
    return authMaterialNomCognoms ? null : "Heu d'indicar una resposta"
  }

  const validaAuthMaterialExposat = () => {
    return authMaterialExposat ? null : "Heu d'indicar una resposta"
  }

  const validaAuthInternet = () => {
    return authInternet ? null : "Heu d'indicar una resposta"
  }

  const validaAuthSortides = () => {
    return authSortides === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthDanys = () => {
    return authDanys === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthCompromis = () => {
    return authCompromis === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthPortatils = () => {
    return authPortatils === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthGDPR = () => {
    return authGDPR === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthImatgeProhibicions = () => {
    return authImatgeProhibicions === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthQuota = () => {
    return authQuota === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthResponsable = () => {
    return authResponsable === "1" ? null : "Aquest camp és obligatori"
  }

  const handleChangeIntranet = (t) => { setAuthIntranet(t) }
  const handleChangePublicacions = (t) => { setAuthPublicacions(t) }
  const handleChangeInternet = (t) => { setAuthInternet(t) }
  const handleChangeMaterial = (t) => { setAuthMaterial(t) }
  const handleChangeMaterialNomCognoms = (t) => { setAuthMaterialNomCognoms(t) }
  const handleChangeMaterialInicials = (t) => { setAuthMaterialInicials(t) }
  const handleChangeMaterialExposat = (t) => { setAuthMaterialExposat(t) }

  const handleChangeCompromis = (t) => {
    setAuthCompromis(t === "0" ? "1" : "0")
    handleDadesAutoritzacions(false)
  }

  const handleChangeGDPR = (t) => {
    setAuthGDPR(t === "0" ? "1" : "0")
    handleDadesAutoritzacions(false)
  }

  const handleChangeImatgeProhibicions = (t) => {
    setAuthImatgeProhibicions(t === "0" ? "1" : "0")
    handleDadesAutoritzacions(false)
  }

  const handleChangeResponsable = (t) => {
    setAuthResponsable(t === "0" ? "1" : "0")
    handleDadesAutoritzacions(false)
  }

  const handleChangePortatils = (t) => {
    setAuthPortatils(t === "0" ? "1" : "0")
    handleDadesAutoritzacions(false)
  }

  const handleChangeSortides = (t) => {
    setAuthSortides(t === "0" ? "1" : "0")
    handleDadesAutoritzacions(false)
  }

  const handleChangeSortidaHorari = (t) => {
    setAuthSortidaHorari(t === "0" ? "1" : "0")
    handleDadesAutoritzacions(false)
  }

  const handleChangeSortidaEsbarjo = (t) => {
    setAuthSortidaEsbarjo(t === "0" ? "1" : "0")
    handleDadesAutoritzacions(false)
  }

  const handleChangeDanys = (t) => {
    setAuthDanys(t === "0" ? "1" : "0")
    handleDadesAutoritzacions(false)
  }

  const handleChangeQuota = (t) => {
    setAuthQuota(t === "0" ? "1" : "0")
    handleDadesAutoritzacions(false)
  }

  const handleChangeMedica = (t) => {
    setAuthMedica(t === "0" ? "1" : "0")
    handleDadesAutoritzacions(false)
  }

  /* VALIDA AUTORITZACIONS */
  const validaAutoritzacions = (e) => {
    if (e) e.preventDefault();

    let error = {}

    error.authIntranet = validaAuthIntranet();
    handleErrors('authIntranet', error)

    error.authPublicacions = validaAuthPublicacions();
    handleErrors('authPublicacions', error)

    error.authMaterial = validaAuthMaterial();
    handleErrors('authMaterial', error)

    error.authMaterialInicials = validaAuthMaterialInicials();
    handleErrors('authMaterialInicials', error)

    error.authMaterialNomCognoms = validaAuthMaterialNomCognoms();
    handleErrors('authMaterialNomCognoms', error)

    error.authMaterialExposat = validaAuthMaterialExposat();
    handleErrors('authMaterialExposat', error)

    error.authInternet = validaAuthInternet();
    handleErrors('authInternet', error)

    error.authCompromis = validaAuthCompromis();
    handleErrors('authCompromis', error)

    if (authPortatilsCriteria) {
      error.authPortatils = validaAuthPortatils();
      handleErrors('authPortatils', error)
    }

    error.authGDPR = validaAuthGDPR();
    handleErrors('authGDPR', error)

    error.authImatgeProhibicions = validaAuthImatgeProhibicions();
    handleErrors('authImatgeProhibicions', error)

    error.authQuota = validaAuthQuota();
    handleErrors('authQuota', error)

    error.authResponsable = validaAuthResponsable();
    handleErrors('authResponsable', error)

    if (major18) {

      if (!esMonografic) {
        error.authSortides = validaAuthSortides();
        handleErrors('authSortides', error)
      }

    }
    else {

      error.authDanys = validaAuthDanys();
      handleErrors('authDanys', error)

    }

    setErrors(error)

    let noError = true;
    //DEVELOP
    if (!config.develop) // bypass errors if develop == true
    {
      Object.keys(error).map((k) => { if (error[k] !== null) noError = false })
    }

    handleDadesAutoritzacions(noError)

    if (noError) {
      setAuthorizationsOpen(false);
    }

    return noError;
  }

  return (
    <div className="container authorizations">
      <div className="row">
        <div className="col col-12 ">
          <div className="t-Region t-Region--hideShow is-expanded t-Region--scrollBody t-Form--noPadding margin-top-sm margin-bottom-none margin-left-none margin-right-none a-Collapsible">
            <div className="t-Region-header">
              <div className="t-Region-headerItems  t-Region-headerItems--controls">
                <button
                  className="t-Button t-Button--icon t-Button--hideShow"
                  type="button"
                  onClick={toggleAuthorizationsOpen}
                >
                  {authorizationsOpen && (
                    <FontAwesomeIcon
                      icon={faChevronUp}
                      fontSize="18"
                      className="t-Icon"
                    />
                  )}
                  {!authorizationsOpen && (
                    <FontAwesomeIcon
                      icon={faChevronDown}
                      fontSize="18"
                      className="t-Icon"
                    />
                  )}
                </button>
              </div>
              <div className="t-Region-headerItems t-Region-headerItems--title">
                <h2 className="t-Region-title a-Collapsible-heading">
                  Protecció de dades
                </h2>
              </div>
              <div className="t-Region-headerItems t-Region-headerItems--buttons"></div>
            </div>
            <div className="t-Region-bodyWrap">
              <Dropdown open={authorizationsOpen}>
                <div className="t-Region-body a-Collapsible-content">
                  <div className="container">
                    <div className="row">
                      <div className="col col-12 ">
                        <div className="t-Region t-Region--noPadding t-Region--removeHeader t-Region--noBorder t-Region--scrollBody t-Form--noPadding t-Form--leftLabels margin-top-sm">
                          <div className="t-Region-bodyWrap">
                            <div className="t-Region-body">
                              <div className="container">

                                {major16 ? (
                                  <AuthCompromis auth={authCompromis} handleChange={handleChangeCompromis} error={errors.authCompromis} enguany={props.enguany} anyVinent={props.anyVinent} />
                                ) : (
                                  <AuthCompromisMenors16 auth={authCompromis} handleChange={handleChangeCompromis} error={errors.authCompromis} enguany={props.enguany} anyVinent={props.anyVinent} />
                                )}

                                <AuthImatgeMaterial
                                  enguany={props.enguany} anyVinent={props.anyVinent}
                                  authIntranet={authIntranet} handleChangeIntranet={handleChangeIntranet} errorIntranet={errors.authIntranet}
                                  authPublicacions={authPublicacions} handleChangePublicacions={handleChangePublicacions} errorPublicacions={errors.authPublicacions}
                                  authInternet={authInternet} handleChangeInternet={handleChangeInternet} errorInternet={errors.authInternet}
                                  authMaterial={authMaterial} handleChangeMaterial={handleChangeMaterial} errorMaterial={errors.authMaterial}
                                  authMaterialNomCognoms={authMaterialNomCognoms} handleChangeMaterialNomCognoms={handleChangeMaterialNomCognoms} errorMaterialNomCognoms={errors.authMaterialNomCognoms}
                                  authMaterialInicials={authMaterialInicials} handleChangeMaterialInicials={handleChangeMaterialInicials} errorMaterialInicials={errors.authMaterialInicials}
                                  authMaterialExposat={authMaterialExposat} handleChangeMaterialExposat={handleChangeMaterialExposat} errorMaterialExposat={errors.authMaterialExposat}
                                  authImatgeProhibicions={authImatgeProhibicions} handleChangeImatgeProhibicions={handleChangeImatgeProhibicions} errorImatgeProhibicions={errors.authImatgeProhibicions}
                                />

                                {authPortatilsCriteria && (
                                  <AuthPortatils auth={authPortatils} handleChange={handleChangePortatils} error={errors.authPortatils} />
                                )}

                                <AuthGDPR auth={authGDPR} handleChange={handleChangeGDPR} error={errors.authGDPR} />

                                {!major18 ? (
                                  <>
                                    {!esMonografic && (
                                      <AuthSortidesMenors auth={authSortides} handleChange={handleChangeSortides} error={errors.authSortides} />
                                    )}

                                    <AuthSortidaEsbarjo auth={authSortidaEsbarjo} handleChange={handleChangeSortidaEsbarjo} error={errors.authSortidaEsbarjo} />

                                    <AuthSortidaHorari auth={authSortidaHorari} handleChange={handleChangeSortidaHorari} error={errors.authSortidaHorari} />

                                    <AuthDanysMenors auth={authDanys} handleChange={handleChangeDanys} error={errors.authDanys} />
                                  </>
                                ) : (
                                  <>
                                    {!esMonografic && (
                                      <AuthSortides auth={authSortides} handleChange={handleChangeSortides} error={errors.authSortides} />
                                    )}

                                    <AuthDanys auth={authDanys} handleChange={handleChangeDanys} error={errors.authDanys} />
                                  </>
                                )}

                                {!major18 && (
                                  <>
                                    <br />
                                    <AuthMedica auth={authMedica} handleChange={handleChangeMedica} error={errors.authMedica} />
                                    <br />
                                  </>
                                )}

                                <br />

                                <AuthQuota auth={authQuota} handleChange={handleChangeQuota} error={errors.authQuota} />

                                <br />

                                <AuthResponsable auth={authResponsable} handleChange={handleChangeResponsable} error={errors.authResponsable} />

                                <AuthEdat17 edat={props.dadesPersonals.edat} />

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="container">
                    <div className="row">
                      <div className="col col-12" align="center">
                        <button onClick={validaAutoritzacions} className="button">SEGÜENT</button>
                      </div>
                    </div>
                  </div>

                </div>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
